export default __webpack_public_path__ + "media/bundles/App/layout/icon/svgs/caret-left-368e53a6548d5661107f37872c5ae061.svg";